import React from 'react';
import { ScrollView } from 'react-native';
import ModalBase from 'src/components/10-atoms/modals/ModalBase';
import withThemeProvider from 'src/customizations/themes/hoc/withThemeProvider';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
const PDFViewer = ({ isVisible, onClose, src, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    return (React.createElement(ModalBase, { animationIn: "zoomIn", animationOut: "zoomOut", isVisible: isVisible, onDismiss: onClose, propagateSwipe: false, showCloseButton: true, style: { backgroundColor: theme.palette.background.main } },
        React.createElement(ScrollView, { contentContainerStyle: { flex: 1 } },
            React.createElement("object", { data: src, type: "application/pdf", width: "100%", height: "100%" }))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default withThemeProvider(PDFViewer, 'light');
